<template>
  <div>
    <BaseExperiment name="cancel_flow_redesign">
      <template
        v-for="(slot, name) in $slots"
        :key="name"
        #[name]>
        <slot :name/>
      </template>
    </BaseExperiment>
  </div>
</template>

<script setup>
import BaseExperiment from '@shared/components/BaseExperiment.vue'
</script>
